import React from 'react';
import { X } from 'lucide-react';
import SubscriptionPlans from './SubscriptionPlans';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import './SubscriptionModal.css';

const SubscriptionModal = ({ isOpen, onClose, currentPlan = 'free', onSelectPlan }) => {
  const { language } = useLanguage();
  const t = translations[language];

  if (!isOpen) return null;

  const handleSelectPlan = (plan) => {
    // Call parent handler if provided
    onSelectPlan?.(plan);
    
    // Close modal after selection (you might want to wait for payment confirmation)
    // onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="subscription-modal-overlay" onClick={handleOverlayClick}>
      <div className="subscription-modal-content">
        {/* Modal Header */}
        <div className="subscription-modal-header">
          <div>
            <h2>{t.pricing?.changePlan || 'Change Your Plan'}</h2>
            <p>{t.pricing?.selectNewPlan || 'Select a new plan to upgrade or downgrade'}</p>
          </div>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close">
            <X size={24} />
          </button>
        </div>

        {/* Plans Component */}
        <div className="subscription-modal-body">
          <SubscriptionPlans
            currentPlan={currentPlan}
            onSelectPlan={handleSelectPlan}
            showAsModal={true}
          />
        </div>

        {/* Modal Footer */}
        <div className="subscription-modal-footer">
          <p className="modal-footer-note">
            {t.pricing?.changeNote || 'Changes will take effect immediately. Prorated charges may apply.'}
          </p>
          <button className="btn-cancel-modal" onClick={onClose}>
            {t.cancel || 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
